var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mural-card" }, [
    _c(
      "div",
      {
        staticClass: "flex items-center justify-between mb-1",
        staticStyle: { gap: "1rem" },
      },
      [
        _c("h4", { staticClass: "mb-0 mural-side-title" }, [
          _vm._v(_vm._s(_vm.$t("mural.upcoming.title"))),
        ]),
        _c(
          "a",
          {
            staticClass: "mural-link",
            on: {
              click: function ($event) {
                return _vm.$emit("go-agenda")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("mural.upcoming.see_agenda")))]
        ),
      ]
    ),
    _c(
      "div",
      { staticClass: "flex flex-column", staticStyle: { gap: ".9rem" } },
      [
        _vm._l(_vm.items, function (item) {
          return _c(
            "div",
            {
              key: item.key,
              staticClass: "mural-upcoming",
              on: {
                click: function ($event) {
                  return _vm.$emit("select", item.payload)
                },
              },
            },
            [
              _c("div", { staticClass: "mural-upcoming__when" }, [
                _c("div", { staticClass: "mural-upcoming__time" }, [
                  _vm._v(_vm._s(item.startTime)),
                ]),
                _c("div", { staticClass: "mural-upcoming__day" }, [
                  _vm._v(_vm._s(item.dayLabel)),
                ]),
              ]),
              _c("span", {
                staticClass: "mural-upcoming__bar",
                style: { background: item.color },
              }),
              _c("div", { staticClass: "mural-upcoming__main" }, [
                _c("div", { staticClass: "mural-upcoming__title" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
                _c("div", { staticClass: "mural-upcoming__sub" }, [
                  _vm._v(_vm._s(item.subtitle)),
                ]),
              ]),
              _c("div", { staticClass: "mural-upcoming__occ" }, [
                _c("div", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(item.occupancy)),
                ]),
                _c("div", { staticClass: "mural-upcoming__track" }, [
                  _c("div", {
                    style: {
                      width: item.percent + "%",
                      background: item.color,
                    },
                  }),
                ]),
              ]),
            ]
          )
        }),
        !_vm.items.length
          ? _c("div", { staticClass: "text-center text-muted py-3" }, [
              _c("small", [_vm._v(_vm._s(_vm.$t("mural.upcoming.empty")))]),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }